var _path, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaiwan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_85)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_85",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H25V19H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H28V19H1V1Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H14.5V10H1V1Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7746 5.75882L6.68085 6.11882L7.03335 6.21632L6.96585 5.95007L6.7746 5.75882ZM8.53335 5.95007L8.46585 6.21632L8.81835 6.11882L8.7246 5.75882L8.53335 5.95007ZM6.96585 5.05007L6.7746 5.24132L6.84585 5.50007L6.96585 5.05007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84634 5.50004L6.77509 5.75879L6.96634 5.95004L6.84634 5.50004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77431 5.24134L6.51556 5.50009L6.77431 5.75884L6.84556 5.50009L6.77431 5.24134ZM7.29931 6.28384L7.49056 6.47509L7.74931 6.40384L7.29931 6.28384ZM8.00806 6.47509L8.36806 6.56884L8.46556 6.21634L8.19931 6.28384L8.00806 6.47509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19964 6.28372L8.46589 6.21622L8.53339 5.94997L8.19964 6.28372ZM7.03339 6.21622L7.13089 6.56872L7.49089 6.47497L7.29964 6.28372L7.03339 6.21622ZM7.74964 6.40372L8.00839 6.47497L8.19964 6.28372L7.74964 6.40372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49085 6.47496L7.7496 6.73371L8.00835 6.47496L7.7496 6.40371L7.49085 6.47496ZM7.03335 4.78371L6.68085 4.88121L6.7746 5.24121L6.96585 5.04996L7.03335 4.78371ZM6.96585 5.94996L7.03335 6.21621L7.2996 6.28371L6.96585 5.94996ZM8.65335 5.49996L8.7246 5.24121L8.53335 5.04996L8.65335 5.49996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29939 4.71631L7.03314 4.78381L6.96564 5.05006L7.29939 4.71631ZM8.53314 5.05006L8.46564 4.78381L8.19939 4.71631L8.53314 5.05006ZM8.72439 5.75881L8.98314 5.50006L8.72439 5.24131L8.65314 5.50006L8.72439 5.75881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53333 5.05002L8.19958 4.71627L7.74958 4.59627L7.29958 4.71627L6.96583 5.05002L6.84583 5.50002L6.96583 5.95002L7.29958 6.28377L7.74958 6.40377L8.19958 6.28377L8.53333 5.95002L8.65333 5.50002L8.53333 5.05002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53339 5.94992L8.72464 5.75867L8.65339 5.49992L8.53339 5.94992ZM8.72464 5.24117L8.81839 4.88117L8.46589 4.78367L8.53339 5.04992L8.72464 5.24117ZM8.46589 4.78367L8.36839 4.43117L8.00839 4.52492L8.19964 4.71617L8.46589 4.78367ZM7.49089 4.52492L7.13089 4.43117L7.03339 4.78367L7.29964 4.71617L7.49089 4.52492ZM7.74964 4.59617L7.49089 4.52492L7.29964 4.71617L7.74964 4.59617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00865 4.52508L7.7499 4.26633L7.49115 4.52508L7.7499 4.59633L8.00865 4.52508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19931 4.71628L8.00806 4.52503L7.74931 4.59628L8.19931 4.71628ZM7.49056 6.47503L7.13056 6.56878L7.29931 7.19128L7.74931 6.73378L7.49056 6.47503ZM7.29931 7.19128L7.74931 8.87503L8.19931 7.19128L7.74931 6.73378L7.29931 7.19128ZM7.03306 6.21628L6.68056 6.11878L6.51556 6.73378L7.13056 6.56878L7.03306 6.21628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51565 6.73372L6.06565 8.42497L7.2994 7.19122L7.13065 6.56872L6.51565 6.73372ZM6.06565 5.94997L4.8244 7.19122L6.51565 6.73372L6.68065 6.11872L6.06565 5.94997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77436 5.75887L6.51561 5.50012L6.06561 5.95012L6.68061 6.11887L6.77436 5.75887ZM6.77436 5.24137L6.68061 4.88137L6.06561 5.05012L6.51561 5.50012L6.77436 5.24137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06601 5.05006L4.37476 5.50006L6.06601 5.95006L6.51601 5.50006L6.06601 5.05006ZM9.44101 5.95006L8.81851 6.11881L8.98351 6.73381L10.6748 7.19131L9.44101 5.95006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46601 6.21629L8.36851 6.56879L8.98351 6.73379L8.81851 6.11879L8.46601 6.21629ZM8.00851 6.47504L7.74976 6.73379L8.19976 7.19129L8.36851 6.56879L8.00851 6.47504ZM8.72476 5.75879L8.81851 6.11879L9.44101 5.95004L8.98351 5.50004L8.72476 5.75879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1994 7.19138L9.44065 8.42513L8.98315 6.73388L8.36815 6.56888L8.1994 7.19138ZM8.46565 4.78388L8.81815 4.88138L8.98315 4.26638L8.36815 4.43138L8.46565 4.78388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44065 5.04997L10.6744 3.81622L8.98315 4.26622L8.81815 4.88122L9.44065 5.04997ZM8.98315 4.26622L9.44065 2.57497L8.1994 3.81622L8.36815 4.43122L8.98315 4.26622ZM9.44065 5.94997L11.1244 5.49997L9.44065 5.04997L8.98315 5.49997L9.44065 5.94997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72436 5.24122L8.98311 5.49997L9.44061 5.04997L8.81811 4.88122L8.72436 5.24122ZM7.29936 3.81622L6.06561 2.57497L6.51561 4.26622L7.13061 4.43122L7.29936 3.81622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03306 4.78383L7.13056 4.43133L6.51556 4.26633L6.68056 4.88133L7.03306 4.78383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51565 4.26618L4.8244 3.81618L6.06565 5.04993L6.68065 4.88118L6.51565 4.26618ZM8.00815 4.52493L8.36815 4.43118L8.1994 3.81618L7.7494 4.26618L8.00815 4.52493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19962 3.81629L7.74962 2.12504L7.29962 3.81629L7.74962 4.26629L8.19962 3.81629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4908 4.52499L7.74955 4.26624L7.29955 3.81624L7.1308 4.43124L7.4908 4.52499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74962 7.41627C8.80794 7.41627 9.66587 6.55834 9.66587 5.50002C9.66587 4.4417 8.80794 3.58377 7.74962 3.58377C6.69131 3.58377 5.83337 4.4417 5.83337 5.50002C5.83337 6.55834 6.69131 7.41627 7.74962 7.41627Z",
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74991 7.19132C8.68396 7.19132 9.44116 6.43412 9.44116 5.50007C9.44116 4.56602 8.68396 3.80882 7.74991 3.80882C6.81585 3.80882 6.05865 4.56602 6.05865 5.50007C6.05865 6.43412 6.81585 7.19132 7.74991 7.19132Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8125,
    y: 0.8125,
    width: 24.375,
    height: 18.375,
    stroke: "#E8E8E8",
    strokeWidth: 0.375
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiwan);
export default __webpack_public_path__ + "static/media/taiwan.852209e5da5b18e7bf1e3f609b08bb84.svg";
export { ForwardRef as ReactComponent };